var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _rect9, _path, _path2, _path3, _path4, _rect10, _rect11, _rect12, _rect13, _path5, _rect14, _rect15, _rect16, _path6, _rect17, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path8, _rect18, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObiWan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0own{fill:#2D2D2D;}\r\n\t.st1own{opacity:0.53;fill:#111110;}\r\n\t.st2own{fill:#161616;}\r\n\t.st3own{fill:#5F5F5E;}\r\n\t.st4own{fill:#A8A7A6;}\r\n\t.st5own{fill:#929292;}\r\n\t.st6own{fill:#9C7034;}\r\n\t.st7own{opacity:0.56;fill:#444444;}\r\n\t.st8own{fill:#9E9B5A;}\r\n\t.st9own{fill:#424241;}\r\n\t.st10own{fill:#4A494A;}\r\n\t.st11own{fill:#8C8A4A;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: 147.9,
    className: "st0own",
    width: 24.8,
    height: 26.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2own",
    cx: 25.9,
    cy: 161,
    rx: 5.4,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3own",
    cx: 25.9,
    cy: 161,
    rx: 3,
    ry: 3.2
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1,
    y: 147.9,
    className: "st1own",
    width: 1.2,
    height: 26.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4own",
    d: "M6.9,172.8c3.5,0.6,7.6,1.1,12.1,1.1c4.8,0.1,9-0.2,12.7-0.7c0,2.1,0,4.2,0,6.3c0.7,0.1,1.8,0.3,2.5,1.1 c0.8,0.9,0.7,1.8,0.7,6.2c0,3.7,0.1,4.4-0.5,5.4c-0.7,1.1-1.8,1.6-2.5,1.8c0.1,0.7,0.2,2.3-0.6,3.5c-0.8,1.2-2,1.5-2.8,1.7 c-6.7,1.6-15.1,0.5-17.7,0.2c-0.7-0.1-1.2-0.2-1.6-0.2c-0.3-0.1-1.5-0.5-2.3-2c-0.9-1.7-0.4-3.4-0.3-3.6c-0.3-0.2-0.6-0.4-1-0.8 c-1.8-1.9-1.7-4.8-1.7-6.7c0.1-2,0.1-3.9,1.5-5.3c0.6-0.6,1.2-0.9,1.7-1C7,177.5,6.9,175.1,6.9,172.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5own",
    d: "M11.5,192.3H7c-0.9,0-1.6-0.7-1.6-1.6v-8c0-0.9,0.7-1.6,1.6-1.6h4.5c0.9,0,1.6,0.7,1.6,1.6v8 C13.1,191.6,12.4,192.3,11.5,192.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5own",
    d: "M32.1,192.3h-4.4c-0.9,0-1.6-0.7-1.6-1.6v-8c0-0.9,0.7-1.6,1.6-1.6h4.4c0.9,0,1.6,0.7,1.6,1.6v8 C33.7,191.6,33,192.3,32.1,192.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5own",
    d: "M21.6,191.8h-4.1c-0.9,0-1.6-0.7-1.6-1.6v-7c0-0.9,0.7-1.6,1.6-1.6h4.1c0.9,0,1.6,0.7,1.6,1.6v7 C23.1,191.1,22.4,191.8,21.6,191.8z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2,
    y: 22.4,
    className: "st6own",
    width: 10.6,
    height: 13.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 16.5,
    className: "st5own",
    width: 16.5,
    height: 5.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 6.3,
    className: "st5own",
    width: 24.1,
    height: 10.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 4,
    className: "st5own",
    width: 26.4,
    height: 2.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5own",
    d: "M34.2,4.2H3.4C3,4.2,2.6,3.8,2.6,3.4V0.8C2.6,0.4,3,0,3.4,0l30.7,0C34.6,0,35,0.4,35,0.8v2.5 C35,3.8,34.6,4.2,34.2,4.2z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 0,
    className: "st7own",
    width: 0.5,
    height: 22.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 50.2,
    className: "st8own",
    width: 9.2,
    height: 9.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 44.2,
    className: "st8own",
    width: 11,
    height: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8own",
    d: "M14.5,45.1c-0.1-0.2-0.3-0.8-0.9-1.2c-1-0.7-2.2-0.1-2.3-0.1c-1,0-1.9,0-2.9,0c0-0.6,0-1.3,0-1.9 c0.7,0.2,1.4-0.3,1.4-0.9c0.1-0.5-0.2-1-0.8-1.2c0-1.8,0-3.6,0-5.4c0-0.1-0.1-0.3,0-0.5c0.1-0.2,0.3-0.2,0.5-0.2 c0.5-0.1,0.7-0.1,1-0.1c0.6,0.1,6.7,0.1,16.2,0c0.3,0,1,0,1.5,0.1c0.1,0,0.3,0,0.3,0.2c0.1,0.2,0,0.5,0,0.5c0,1.8,0,3.5,0,5.3 c-0.5-0.1-0.9,0.1-1.1,0.5c-0.1,0.2-0.1,0.4-0.1,0.6c0.1,0.5,0.8,0.9,1.8,1c0,0.7,0,1.3,0,2c-0.9,0-1.9,0-2.8,0 c-0.2-0.1-0.4-0.3-0.8-0.4c-0.8-0.2-1.4,0.3-1.5,0.4c-0.3,0.4-0.6,0.7-0.9,1.1C20.3,45,17.4,45,14.5,45.1z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 59.1,
    className: "st9own",
    width: 16,
    height: 52.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9own",
    d: "M30,112.4H8.7c-0.2,0-0.3-0.1-0.3-0.3v-4.5c0-0.2,0.1-0.3,0.3-0.3H30c0.2,0,0.3,0.1,0.3,0.3v4.5 C30.3,112.3,30.1,112.4,30,112.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19.1,
    cy: 62.3,
    rx: 11.1,
    ry: 2.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19.1,
    cy: 67.6,
    rx: 11.1,
    ry: 2.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19,
    cy: 72.8,
    rx: 11.1,
    ry: 2.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19.2,
    cy: 77.7,
    rx: 11.1,
    ry: 2.6
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19.2,
    cy: 82.9,
    rx: 11.1,
    ry: 2.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19,
    cy: 88.2,
    rx: 11.1,
    ry: 2.6
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19.2,
    cy: 93.1,
    rx: 11.1,
    ry: 2.6
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19,
    cy: 98.4,
    rx: 11.1,
    ry: 2.6
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9own",
    cx: 19.2,
    cy: 103.4,
    rx: 11.1,
    ry: 2.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5own",
    d: "M6.9,148.1c3.2,0.7,7.1,1.2,11.4,1.3c5.1,0.1,9.6-0.5,13.2-1.3c0-12.2,0-24.4,0-36.6c-7.8,0-15.6,0-23.5,0 c0,0.7,0,1.5,0,2.2c-1.6,0-3.2,0-4.9,0c0,12,0.1,23.9,0.1,35.9c1.2,0,2.4,0,3.6,0C6.9,149.1,6.9,148.6,6.9,148.1z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 111.5,
    className: "st10own",
    width: 1.1,
    height: 37.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10own",
    d: "M12,148.9c-0.3,0-0.6-0.1-0.9-0.1c0-11.5,0-23.1,0-34.6H12C12,125.8,12,137.4,12,148.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10own",
    d: "M6.9,148.9c-0.3,0-0.6,0-0.8,0c0-11.6,0-23.2,0-34.8h0.8C6.8,125.8,6.8,137.4,6.9,148.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10own",
    d: "M3.2,114.8c0-0.3,0-0.6,0-0.9c2.9,0,5.9,0,8.8,0v0.9C9,114.8,6.1,114.8,3.2,114.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10own",
    d: "M3.3,149.1c0-0.2,0-0.4,0-0.6c1.2,0,2.3,0,3.5,0v0.6C5.6,149.1,4.5,149.1,3.3,149.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10own",
    d: "M30.3,148.3c-0.2,0-0.4,0.1-0.6,0.1c0-12.3,0-24.6,0-36.9h0.6C30.3,123.8,30.3,136.1,30.3,148.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11own",
    d: "M3.3,149.6c-1.1-0.9-2.2-1.7-3.3-2.6v-33.1h3.4C3.3,125.8,3.3,137.7,3.3,149.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObiWan);
export default __webpack_public_path__ + "static/media/obi-wan.217b684b.svg";
export { ForwardRef as ReactComponent };